import { getCurrency } from '@common/utils/currency.ts'

import { PpvTrackingCategory } from '@/modules/tracking/ppv/types.ts'
import { getPercentValue } from '@/utils/helpers'

import { PpvStatsItem } from '../PpvStatsItem.tsx'

interface PpvCategoryStatsProps {
  category: PpvTrackingCategory
}

export const PpvCategoryStats = ({ category }: PpvCategoryStatsProps) => {
  return (
    <div className="mb-8 mt-6 flex flex-wrap gap-8">
      {category && (
        <div className="flex w-full gap-2">
          <PpvStatsItem
            field="Revenue"
            value={getCurrency(category.netRevenue)}
          />
          <PpvStatsItem
            field="Purchase Rate"
            value={getPercentValue(category.purchaseRate)}
          />
          <PpvStatsItem
            field="Purchases"
            value={`${category.boughtAmount}`}
          />
        </div>
      )}
    </div>
  )
}
